import React, { FC } from 'react';
import { Dialog, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Content } from 'components/modals/PromotionModal/Modal';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  src: string;
  title: string;
  description: string;
  date: string;
}

const Modal: FC<ModalProps> = ({
  isOpen,
  onClose,
  src,
  title,
  description,
  date,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        '.MuiDialog-paper': {
          borderRadius: '30px',
          overflowY: 'inherit',
          maxWidth: '500px',
        },
      }}
    >
      <IconButton
        sx={{ position: 'absolute', top: '-10px', right: '-65px' }}
        onClick={onClose}
        size="large"
        aria-label="close-btn"
      >
        <CloseIcon sx={{ color: 'common.white' }} fontSize="large" />
      </IconButton>
      <Content src={src} title={title} description={description} date={date} />
    </Dialog>
  );
};

export default Modal;
